import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { GenericFormBtnComponent } from './generic-btn.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
    ],
    declarations: [
        GenericFormBtnComponent,
    ],
    exports: [
        GenericFormBtnComponent,
    ]
})
export class GenericFormBtnModule { }
